module.exports = __webpack_public_path__ + "static/img/品牌实力.e2951ece.png";